// src/services/selldo.js
import {
  SELLDO_CAMPAIGNS,
  findGoogleCampaignByLandingPath,
  normalizeCampaignName,
} from "../config/sellDoCampaigns";
import {
  getActiveCampaignName,
  isGoogleAdsVisit,
} from "../utils/campaignTracking";

// Confirmed contract from the Sell.Do CRM team — flat query-string GET,
// no form_id. Do NOT paste the real api_key into chat/anywhere public.
const SELLDO_API_URL = "https://app.sell.do/api/leads/create";
const SELLDO_API_KEY = "1173efa0ff109f2cf5da1657b6d6641c";

// Their sample used plain digits (e.g. "9299999990"), no +91 prefix.
const formatPhone = (mobile) => String(mobile).replace(/\D/g, "");

export const sendLeadToSellDo = async ({
  name,
  email,
  mobile,
  city = "",
  visitDate = "",
  source = "Website",
  referrer,
  campaignName,
}) => {
  const activeCampaignName = campaignName || getActiveCampaignName();
  let campaignRecord = activeCampaignName
    ? SELLDO_CAMPAIGNS[normalizeCampaignName(activeCampaignName)]
    : null;

  // Google auto-tagging supplies a click id, not the campaign name. For known
  // dedicated landing pages, resolve the page to its Sell.Do campaign/SRD.
  if (!campaignRecord && isGoogleAdsVisit()) {
    campaignRecord = findGoogleCampaignByLandingPath(window.location.pathname);
  }

  if (activeCampaignName && !campaignRecord) {
    console.warn(
      `Sell.Do campaign not configured for incoming campaign: "${activeCampaignName}"`,
    );
  }

  const srd = campaignRecord ? campaignRecord.srd : "";
  const projectName = campaignRecord ? campaignRecord.projectName : "";
  const projectId = campaignRecord ? campaignRecord.projectId || "" : "";
  const sourceName = campaignRecord ? campaignRecord.sourceName : "Website";
  const subSourceName = campaignRecord
    ? campaignRecord.subSourceName
    : "Organic";

  // Only name/email/phone/srd/note are confirmed fields for this account,
  // so everything else rides along as readable text inside the note.
  const noteContent = [
    `Form: ${source}`,
    city && `City: ${city}`,
    visitDate && `Visit date: ${visitDate}`,
    `Landing: ${referrer || window.location.href}`,
    campaignRecord
      ? `Matched ad campaign: ${campaignRecord.campaignName} | Project: ${projectName} | Source: ${sourceName} / ${subSourceName}`
      : "Matched ad campaign: Organic / Direct",
  ]
    .filter(Boolean)
    .join(" | ");

  const params = new URLSearchParams({
    api_key: SELLDO_API_KEY,
    "sell_do[form][lead][name]": name,
    "sell_do[form][lead][email]": email,
    "sell_do[form][lead][phone]": formatPhone(mobile),
    "sell_do[campaign][srd]": srd,
    "sell_do[campaign][source]": sourceName,
    "sell_do[campaign][sub_source]": subSourceName,
    "sell_do[form][lead][project_id]": projectId,
    "sell_do[form][lead][project_name]": projectName,
    "sell_do[form][note][content]": noteContent,
  });

  const url = `${SELLDO_API_URL}?${params.toString()}`;

  console.log(
    "📤 Sending lead to Sell.Do:",
    url.replace(SELLDO_API_KEY, "***"),
  );

  const response = await fetch(url, { method: "GET" });

  if (!response.ok) {
    const errText = await response.text();
    console.error("❌ Sell.Do API error:", response.status, errText);
    throw new Error(`Sell.Do API responded with status ${response.status}`);
  }

  const data = await response.json().catch(() => ({}));
  console.log("✅ Lead synced to Sell.Do:", data);
  return data;
};
